<!-- <div class="action-panel-container border-light primary-bg"> -->
<div class="action-panel-box p-5 border-light primary-bg">
    <div class="action-panel-header">
        <!-- <mat-icon class="primary-text">check_box</mat-icon> -->
        <div class="header-left">
            <h3 class="primary-text lighter-text">Actions</h3>
            <p class="status content-s primary-text bold-text">{{calculateSelectedCount() + " checked actions"}}</p>
        </div>
        <div class="header-right">
            <mat-icon class="primary-text enable-action" (click)="cancelAction()">close</mat-icon>
        </div>

    </div>
    <div class="action-panel-body primary-text" [formGroup]="action_panel">
        <div class="action-item-1 drop-down-style">
            <p class="content-m bold-text">{{actionPanelMetadata.action_headers.action}}</p>
            <div class="next-status-action p-2 radius-m border-light" #nextStatus>
                <app-overlay-select class="" overlaycontainer="border-none shadow-none" [placeHolder]="actionPanelMetadata.action_placeholders.action" [data]="getApplicableActions()" formControlName="action" sort="true"></app-overlay-select>
            </div>
        </div>
        <div class="action-item-2 drop-down-style" *ngIf="!isEmptyObject(current_action) && current_action.priority">
            <p class="content-m bold-text">{{actionPanelMetadata.action_headers.priority}}</p>
            <div class="update-priority p-2 radius-m border-light" #updatePriority>
                <app-overlay-select class="" overlaycontainer="border-none shadow-none" [placeHolder]="actionPanelMetadata.action_placeholders.priority" [data]="sharedservice.priority_option" formControlName="priority" sort="true"></app-overlay-select>
            </div>
        </div>
        <div class="action-item-3 drop-down-style" *ngIf="!isEmptyObject(current_action)  && current_action.reassign">
            <p class="content-m bold-text">{{actionPanelMetadata.action_headers.reassign}}</p>
            <div class="reassign-analyst p-2 radius-m border-light" #reassignAnalyst>
                <app-overlay-select class="" overlaycontainer="border-none shadow-none" [placeHolder]="actionPanelMetadata.action_placeholders.reassign" [data]="sharedservice.analystlist" formControlName="reassign" sort="true"></app-overlay-select>
            </div>
        </div>
        <div class="action-item-4 drop-down-style" *ngIf="!isEmptyObject(current_action)  && current_action.hasReason">
            <p class="content-m bold-text ">{{actionPanelMetadata.action_headers.comment + " " + isCommentOptionalOrMandatory()}}</p>
            <div class="comment p-2 radius-m border-light" #comment>
                <app-overlay-select class="" overlaycontainer="border-none shadow-none" [placeHolder]=" current_action.value == 3 ? actionPanelMetadata.action_placeholders.comment: 'Select Comment'" [data]="getReasons(current_action.value)" formControlName="reason" sort="true"></app-overlay-select>
            </div>
        </div>
    </div>
    <div class="action-panel-footer">
        <div class="action-item-5 submit  primary-text save-action py-1" [ngClass]="action_panel.valid ? 'enable-action ':'disable-action permission-denied'" (click)="saveAction()">
            <!-- <mat-icon>save</mat-icon> -->
            {{actionPanelMetadata.action_buttons.save}}</div>
        <div class="action-item-6 cancel  enable-action clear-action py-1" (click)="cancelAction()">Cancel</div>
    </div>
</div>
<!-- </div> -->